import styled from 'styled-components';

export const SurgicalMeshDetailsContainer = styled.div`
  background-color: #F4F8FF;
  padding-bottom: 48px;
`;

export const SurgicalMeshDetailsTitle = styled.div`
  font-family: Nexa;
  font-weight: 700;
  font-style: Bold;
  font-size: 36px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0%;
  padding-top: 48px;

  @media (max-width: 499px) {
    padding-top: 36px;
    font-size: 24px;
  }
`;

export const TableContainer = styled.div`
  padding: 36px 60px;
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 3 columns */
  gap: 48px; /* space between boxes */

  @media (max-width: 499px) {
    gap: 24px;
    padding: 12px 24px;
  }
`;

export const GridBox = styled.div`
  font-family: Nexa;
  font-weight: 700;
  font-style: Bold;
  font-size: 44px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: bottom;
  background-color: white;
  padding: 80px 60px;

  @media (max-width: 900px) {
    padding: 60px 40px;
    font-size: 32px;
  }

  @media (max-width: 499px) {
    padding: 32px 24px;
    font-size: 16px; 
  }

  &:hover {
    color: #f7941d;
  }
`

export const CTAButton = styled.button`
  margin: 2rem auto 0;
  display: block;
  padding: 12px 24px;
  background: white;
  color: #000;
  font-weight: 600;
  font-size: 16px;
  border: 2px solid #f7941d;
  border-radius: 12px;
  cursor: pointer;
  transition: 0.2s ease;
  margin-top: 14px;

  &:hover {
    background: #f7941d;
    color: white;
  }
`;
